import React from 'react';
import Slider from "react-slick";
import {
    SectionWrapper
} from "../../CommonStyles";
import {
    SliderContainer,
    Container,
    Title,
    Description
} from "./styles";
import Col from '../../../Shared/Kit/Col';
import image1 from "../../../Assets/Images/Banner1.png";
import layerImage from "../../../Assets/Images/Layer.png";

const Banner = () => {
    let settings = {
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 4000,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        pauseOnHover: false,
    };

    const sliderConfig = [
        {
            id: 1,
            image: image1,
            title: "فرصت سرمایه گذاری",
            description: "پروژه ساختمانی منطقه 22"
        },
    ]

    return (
        <SliderContainer>
            <Slider {...settings}>
                {sliderConfig.map((each, index) => {
                    return (
                        <SectionWrapper
                            className="banner"
                            source={each.image}
                            layerSource={layerImage}
                        >
                            <Col className="content">
                                <Container id={`container-${each.id}`} xl={20.8}>
                                    <Title>
                                        {each.title}
                                    </Title>
                                    <Description>
                                        <Col className="line" />
                                        {each.description}
                                    </Description>
                                </Container>
                            </Col>
                            <Col className="layer" />
                            {/* </Col> */}
                        </SectionWrapper>
                    )
                })}
            </Slider>
        </SliderContainer>
    )
}

export default Banner;